import { createSelector } from 'reselect';

const selectForumSubscriptions = (state: any) => state.forumSubscriptions;


export const selectForumSubscriptionsCurrentItem = createSelector([selectForumSubscriptions], (forumSubscriptions) => forumSubscriptions.current);

export const selectForumSubscriptionsListItems = createSelector([selectForumSubscriptions], (forumSubscriptions) => forumSubscriptions.list);

export const selectForumSubscriptionsItemById = (itemId: any) =>
    createSelector(selectForumSubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectForumSubscriptionsQueryItems = createSelector([selectForumSubscriptions], (forumSubscriptions) => forumSubscriptions.query);

export const selectForumSubscriptionsCreatedItem = createSelector([selectForumSubscriptions], (forumSubscriptions) => forumSubscriptions.create);

export const selectForumSubscriptionsUpdatedItem = createSelector([selectForumSubscriptions], (forumSubscriptions) => forumSubscriptions.update);

export const selectForumSubscriptionsReadItem = createSelector([selectForumSubscriptions], (forumSubscriptions) => forumSubscriptions.read);

export const selectForumSubscriptionsDeletedItem = createSelector([selectForumSubscriptions], (forumSubscriptions) => forumSubscriptions.delete);

export const selectForumSubscriptionsSearchedItems = createSelector([selectForumSubscriptions], (forumSubscriptions) => forumSubscriptions.search);

export const selectForumSubscriptionsItemsCount = createSelector([selectForumSubscriptions], (forumSubscriptions) => forumSubscriptions.count);

export const selectForumSubscriptionsItemsFilter = createSelector([selectForumSubscriptions], (forumSubscriptions) => forumSubscriptions.filter);